import { render } from "./PledgeAccordian.vue?vue&type=template&id=ddef20ac"
import script from "./PledgeAccordian.vue?vue&type=script&lang=js"
export * from "./PledgeAccordian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__